/*
 * Author: Dw
 * File Created: Friday, 25-04-25 11:04 am
 * Last Modified: Monday, 25-04-28 10:38 am, by Dw
 */

const DvaultExpanded = () => {
  return <svg width="49" height="30" viewBox="0 0 49 30" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="DvaultExpanded" data-sentry-source-file="index.tsx">
      <path d="M24.5 6C32.232 6 38.5 12.268 38.5 20C38.5 25.5228 42.9772 30 48.5 30H0.5C6.02285 30 10.5 25.5228 10.5 20C10.5 12.268 16.768 6 24.5 6Z" fill="#111217" data-sentry-element="path" data-sentry-source-file="index.tsx" />
      <mask id="mask0_5052_30023" style={{
      maskType: 'alpha'
    }} maskUnits="userSpaceOnUse" x="0" y="0" width="49" height="30" data-sentry-element="mask" data-sentry-source-file="index.tsx">
        <rect width="49" height="30" fill="#D9D9D9" data-sentry-element="rect" data-sentry-source-file="index.tsx" />
      </mask>
      <g mask="url(#mask0_5052_30023)" data-sentry-element="g" data-sentry-source-file="index.tsx">
        <rect x="14.5" y="10" width="20" height="20" rx="10" fill="#232530" data-sentry-element="rect" data-sentry-source-file="index.tsx" />
        <path fillRule="evenodd" clipRule="evenodd" d="M20.0757 22.4242C20.31 22.6586 20.6899 22.6586 20.9243 22.4242L24.5 18.8485L28.0757 22.4242C28.31 22.6586 28.6899 22.6586 28.9243 22.4242C29.1586 22.1899 29.1586 21.81 28.9243 21.5757L24.9243 17.5757C24.6899 17.3414 24.31 17.3414 24.0757 17.5757L20.0757 21.5757C19.8414 21.81 19.8414 22.1899 20.0757 22.4242Z" fill="white" data-sentry-element="path" data-sentry-source-file="index.tsx" />
      </g>
    </svg>;
};
export default DvaultExpanded;